<template>

    <Delivery :entity-type="BUSINESS_TYPE.PHARMACY" />

</template>

<script>
    import Delivery from '@/components/delivery/Delivery';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDelivery',

        components: {
            Delivery,
        },
  
        data () {
            return {
                BUSINESS_TYPE
            }
        },
    
        computed: {},

        mounted() {},

        methods: {}
    }
</script>
